import { OrderType, TaskStatus } from '@exam-management/graphql';

export const ORDER_FIELD_BY_STATUS = {
  [TaskStatus.Todo]: 'dueDate',
  [TaskStatus.InProgress]: 'dueDate',
  [TaskStatus.Completed]: 'completedAt',
};

export const ORDER_TYPE_BY_STATUS = {
  [TaskStatus.Todo]: OrderType.Asc,
  [TaskStatus.InProgress]: OrderType.Asc,
  [TaskStatus.Completed]: OrderType.Desc,
};

export const CARD_LIST_PAGE_SIZE = 10;
